// extracted by mini-css-extract-plugin
export default {"header":"TableTitle_header__YEUQS","textCenter":"TableTitle_textCenter__sADNS","textLeft":"TableTitle_textLeft__mXZOk","textRight":"TableTitle_textRight__xH+ep"};